import { axiosBaseQuery } from '@app/api/make-request'
import { ApiKeys } from '@app/constants/api-keys'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import { createApi } from '@reduxjs/toolkit/query/react'
import localforage from 'localforage'
import { IRtkResponse } from '../types'
import { IPupilPaymentType } from '@app/interfaces/pupil/organization-pupils'

export const pupilPaymentTypesApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'pupilPaymentTypesApi',
  tagTypes: [ApiKeys.pupilPaymentType],
  endpoints: (build) => ({
    getPupilPaymentTypes: build.query<
      IRtkResponse<IPupilPaymentType[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'pupil/api/v1/pupil-payment-types',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IPupilPaymentType[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.pupilPaymentType,
                id,
              })),
              { type: ApiKeys.pupilPaymentType, id: 'LIST' },
            ]
          : [{ type: ApiKeys.pupilPaymentType, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.pupilPaymentType, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
  }),
})

const useStateGetPaymentTypes =
  pupilPaymentTypesApi.endpoints.getPupilPaymentTypes.useQueryState

export const { useGetPupilPaymentTypesQuery } = pupilPaymentTypesApi

export { useStateGetPaymentTypes }
